<template>
  <div id="modal-cart-gifts">
    <Modal
      :show-modal="true"
      titulo="Itens bonificados do pedido"
      @close="close()"
    >
      <div slot="body">
        <template v-if="gifts?.length > 0">
          <div v-for="gift in gifts" class="cart-gift__item">
            <div class="cart-gift__photo">
              <img
                :src="gift.produto?.src"
                :alt="gift.produto?.descricao"
                class="cart-gift__image"
              />
            </div>

            <div class="cart-gift__details">
              <router-link
                class="cart-gift__name"
                :to="{
                  name: 'produtoRota',
                  params: { codigo: gift.produto?.integracao_id },
                }"
                >{{ gift.produto?.descricao }}</router-link
              >

              <span class="cart-gift__quantity">
                Qtd.: {{ gift.quantity }}
              </span>
            </div>
          </div>
          <div>
            <br />
            <small class="cart-gift__obs">
              Observação: Os itens bonificados serão incluídos no pedido após a
              confirmação da compra.
            </small>
          </div>
        </template>
        <span v-else> O pedido não possui nenhum item bonificado. </span>
      </div>
      <div slot="footer">
        <button class="btn btn-primary" @click="close()">Fechar</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/root/modal/Modal.vue";
import bus from "@/utils/events/bus";

export default {
  name: "ModalCartGifts",
  components: {
    Modal,
  },
  props: {
    gifts: {
      type: Object / Array,
      default: () => [],
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
#modal-cart-gifts {
  .modal-container {
    color: #1f1f1f;
    max-width: 600px;
  }

  .cart-gift {
    &__item {
      display: flex;
      align-items: anchor-center;
    }

    &__details {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    &__photo {
      height: 65px;
      width: 65px;
      min-width: 60px;
      text-align: center;
      display: grid;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      overflow: hidden;
    }

    &__name {
      display: -webkit-box;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 15px;
      color: #545454;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      font-weight: 400;
      font-family: "Roboto", sans-serif;

      &:hover {
        color: var(--brand-primary, var(--brand-primary, #160e44));
      }
    }

    &__quantity {
      color: #555;
      font-size: 12px;
    }

    &__image {
      margin: 0 auto;
      max-height: 60px;
      padding: 2px;
      max-width: 60px;
    }

    &__obs {
      color: #606060;
    }
  }
}
</style>
